exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___3OwQV{width:22px;height:22px;border-radius:5px;display:flex;justify-content:center;align-items:center;cursor:pointer}.index-module__wrapper___3OwQV svg{transition:.25s}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___3OwQV"
};